import { driverErrorTooltips, driverWarningTooltips, VEHICLE_WARNING_FALLBACK } from "../fixtures/driver";

export const getDriverErrorTooltip = (error: { key: string; value: string }) => {
  return driverErrorTooltips[error.key as keyof typeof driverErrorTooltips][
    error.value as keyof (typeof driverErrorTooltips)[keyof typeof driverErrorTooltips]
  ];
};

export const getDriverWarningTooltip = (error: string) => {
  // `error` may be a warning key (warning_match_*) or a specific
  // VehicleCorrectErrorMessage reason code. Unknown/future codes fall back to
  // the generic vehicle-fitness message rather than rendering an empty tooltip.
  return driverWarningTooltips[error as keyof typeof driverWarningTooltips] ?? driverWarningTooltips.warning_vehicle_type_incorrect;
};

// Falls back to the generic line when there are no recognised reason codes —
// e.g. an assigned-vs-current vehicle mismatch, which carries none.
export const getVehicleWarningTooltip = (codes: string[] = []) => {
  const messages = codes.map((code) => driverWarningTooltips[code as keyof typeof driverWarningTooltips]).filter(Boolean);

  if (messages.length === 0) return VEHICLE_WARNING_FALLBACK;
  if (messages.length === 1) return messages[0];

  return (
    <ul className="list-disc space-y-1 pl-4">
      {messages.map((message) => (
        <li key={message}>{message}</li>
      ))}
    </ul>
  );
};
